import { LanguageSite } from '@ppg/core/models';

export const PRIMENG_TRANSLATION_KEY = 'PRIMENG_TRANSLATIONS';

export const MOCK_LANGUAGES: LanguageSite[] = [
  {
    name: 'English',
    languageCulture: 'en-US',
    uniqueSeoCode: 'en',
    isDefault: true,
    countryName: 'United States',
    nativeCountryName: 'United States',
    languageName: 'English',
    nativeLanguageName: 'English',
    countryCode: 'US',
  },
  {
    name: 'Germany',
    languageCulture: 'de-DE',
    uniqueSeoCode: 'de',
    isDefault: false,
    countryName: 'Germany',
    nativeCountryName: 'Deutschland',
    languageName: 'German',
    nativeLanguageName: 'Deutsch',
    countryCode: 'DE',
  },
  {
    name: 'Spain',
    languageCulture: 'es-ES',
    uniqueSeoCode: 'es',
    isDefault: false,
    countryName: 'Spain',
    nativeCountryName: 'España',
    languageName: 'Spanish',
    nativeLanguageName: 'Español',
    countryCode: 'ES',
  },
];
